export const renegotiationTypes = {
  PRICE: 'price',
  IRREGULAR: 'irregular'
}

export const renegotiationOptions = [
  { value: renegotiationTypes.PRICE, label: 'Price' },
  { value: renegotiationTypes.IRREGULAR, label: 'Irregular' }
]
